import { motion } from 'framer-motion';
import styles from './Question.module.css';
import { useEffect, useRef, useState } from 'react';

function Question({ title, isLong, questionFontSize }) {
  const [lines, setLines] = useState([]);
  const textRef = useRef(null);
  const containerRef = useRef(null);

  const splitTextIntoLines = (title) => {
    if (!textRef.current || !containerRef.current) return [];

    const container = containerRef.current;
    const tempText = textRef.current;

    if (!title) {
      return [];
    }

    const initialLines = title.split('\n');
    const finalLines = [];

    for (let lineIndex = 0; lineIndex < initialLines.length; lineIndex++) {
      const originalLine = initialLines[lineIndex].trim();

      if (!originalLine) continue;

      const words = originalLine.split(' ');
      let currentLine = '';

      for (let i = 0; i < words.length; i++) {
        const testLine = currentLine ? `${currentLine} ${words[i]}` : words[i];
        tempText.textContent = testLine;

        if (
          tempText.scrollWidth > container.clientWidth &&
          currentLine !== ''
        ) {
          finalLines.push(currentLine);
          currentLine = words[i];
        } else {
          currentLine = testLine;
        }
      }

      if (currentLine) {
        finalLines.push(currentLine);
      }
    }

    return finalLines;
  };

  useEffect(() => {
    const updateLines = (title) => {
      const newLines = splitTextIntoLines(title);
      setLines(newLines);
    };

    updateLines(title);

    window.addEventListener('resize', updateLines);
    return () => window.removeEventListener('resize', updateLines);
  }, [title, questionFontSize]);

  return (
    <div className={styles.block}>
      <div ref={containerRef} style={{ width: '100%', position: 'relative' }}>
        <div
          ref={textRef}
          style={{
            position: 'absolute',
            visibility: 'hidden',
            whiteSpace: 'nowrap',
            fontSize: isLong
              ? `${0.8 * questionFontSize}rem`
              : `${questionFontSize}rem`,
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            textTransform: 'uppercase',
          }}
        />

        <motion.div
          className={styles.question}
          style={{
            fontSize: isLong
              ? `${0.8 * questionFontSize}rem`
              : `${questionFontSize}rem`,
          }}
        >
          {lines.map((line, index) => (
            <motion.div
              key={index}
              initial={{ y: '15rem', opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                delay: index * 0.3 + 0.5,
                duration: 0.5,
                ease: 'easeOut',
              }}
            >
              {line}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}

export default Question;
